var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 233 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A8A",
    fillRule: "nonzero",
    d: "M194,114 C194,112.343146 195.343146,111 197,111 C198.656854,111 200,112.343146 200,114 L200,167.996048 C200,174.624152 194.621459,180 187.997379,180 L121.84062,180 L126.083261,178.242641 L108.486098,195.839804 C103.798971,200.52693 96.202273,200.528175 91.5139019,195.839804 L73.9167389,178.242641 L78.1593796,180 L12.0026208,180 C5.37379703,180 0,174.623913 0,167.996048 L0,12.003952 C0,5.37584786 5.37854098,0 12.0026208,0 L187.997379,0 C194.626203,0 200,5.37608677 200,12.003952 L200,28 C200,29.6568542 198.656854,31 197,31 C195.343146,31 194,29.6568542 194,28 L194,12.003952 C194,8.68983647 191.312535,6 187.997379,6 L12.0026208,6 C8.69374645,6 6,8.68806085 6,12.003952 L6,167.996048 C6,171.310164 8.68746486,174 12.0026208,174 L78.1593796,174 L95.7565426,191.597163 C98.1021518,193.942772 101.899861,193.94076 104.243457,191.597163 L121.84062,174 L187.997379,174 C191.306254,174 194,171.311939 194,167.996048 L194,114 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 82,
    r: 9,
    stroke: "#8A8A8A",
    strokeLinecap: "square",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 82,
    r: 9,
    stroke: "#8A8A8A",
    strokeLinecap: "square",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.5,
    cy: 72.5,
    r: 31.5,
    fill: "#9AA19E"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#9AA19E",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 6,
    points: "187 74.6 195.571 83 217 62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8A8A8A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M72,123 C72,138.4 84.6,151 100,151 C115.4,151 128,138.4 128,123 L72,123 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTasks);
export default __webpack_public_path__ + "static/media/no-tasks.e3f5505e8a543310305d7a66be9bf5fc.svg";
export { ForwardRef as ReactComponent };